import { MutableRefObject } from 'react';

const SliderWrapper = ({
  children,
  sliderRef,
  setIsDragging,
}: {
  children: React.ReactNode;
  sliderRef: MutableRefObject<any>;
  setIsDragging: (isDragging: boolean) => void;
}) => {
  const handleMouseDown = (e: React.MouseEvent) => {
    const dragThreshold = 5;
    setIsDragging(false);
    const mouseStartX = e.pageX - (sliderRef.current?.offsetLeft || 0);
    const sliderScrollLeft = sliderRef.current?.scrollLeft || 0;

    const handleMouseMove = (e: MouseEvent) => {
      const x = e.pageX - (sliderRef.current?.offsetLeft || 0);
      const walk = (x - mouseStartX) * 1.5;
      if (Math.abs(walk) > dragThreshold) {
        setIsDragging(true);
      }
      if (sliderRef.current) {
        sliderRef.current.scrollLeft = sliderScrollLeft.current - walk;
      }
    };

    const handleMouseUp = (e: MouseEvent) => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div className="slider-container" onMouseDown={handleMouseDown}>
      {children}
    </div>
  );
};

export default SliderWrapper;
